import { UsuarioAlerta } from './../../../../dto/usuario-alerta.dto';
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AlertaUsuarioService } from "app/service/alerta-usuario.service";
import { NbToastrService } from "@nebular/theme";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'posponer-dialog',
  templateUrl: './posponer-notificacion.component.html',
  styleUrls: ['./posponer-notificacion.component.scss'],
})
export class PosponerDialog {
  usuarioAlerta = {} as UsuarioAlerta;
  form: FormGroup;
  minDate = new Date();
  constructor(
    private formBuilder: FormBuilder,
    private alertaUsuarioService: AlertaUsuarioService,
    private dialogRef: MatDialogRef<PosponerDialog>,
    private toastrService: NbToastrService,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.form = this.formBuilder.group({
      fecha: ["", [Validators.required]]
    });
    this.usuarioAlerta = data.usuarioAlerta;
  }

  ngOnInit() {
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.form.controls.fecha.valueChanges.subscribe(d => this.usuarioAlerta.fechaPospuesta = d);
  }

  submit() {
    if (this.form.valid) {
      this.alertaUsuarioService.update(this.usuarioAlerta.idUsuarioAlerta, this.usuarioAlerta).toPromise().then(d => {
        this.toastrService.show('', 'La Fecha ha sido actualizada correctamente.', { status: 'success' });
        this.dialogRef.close();
      })
    }
  }
}
